import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import ScreenDisplay from "@/components/ScreenDisplay";
import ScheduleDisplay from "@/components/ScheduleDisplay";
import { Toaster } from "@/components/ui/sonner";

// Dynamic screen wrapper that extracts screen number from pathname
const DynamicScreen = () => {
  const location = useLocation();
  // Extract number from pathname like /ekran1, /ekran2, etc.
  const match = location.pathname.match(/\/ekran(\d+)/);
  const screenId = match ? parseInt(match[1]) : 1;
  return <ScreenDisplay screenId={screenId} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/harmonogram" element={<ScheduleDisplay />} />
          {/* Static routes for screens 1-20 */}
          {[...Array(20)].map((_, i) => (
            <Route key={i + 1} path={`/ekran${i + 1}`} element={<ScreenDisplay screenId={i + 1} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
